/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { api } from "../index";
import { OrderApiProps } from "./modals";

const getAllOrders = async (props: OrderApiProps) =>
  await api.get(
    `/wp-json/wc/v3/orders?lang=${props.lang}&customer=${props.customer}${
      !!props.status ? "status=" + props.status : ""
    }`
  );
const getOrder = async (order_id: string) =>
  await api.get(`/wps/portal/web/eshop/track?order_id=${order_id}`);

export const OrderApi = { getAllOrders, getOrder };
